<div class="caja">
  <img src="assets/img/bannerG.jpg" class="img-fluid" alt="Responsive image">
  <div class="texto2">
    <br>
    <!-- <h1 class="font-weight-bold" style="font-size:5vw;">BIENVENIDO</h1> -->
  </div>
  <div class="texto">
    <!-- 
      <h1 class="font-weight-light" style="font-size:5vw;">EL HUARACHE</h1>
      <h1 class="font-weight-bold" style="font-size:5vw; color: yellow;">SSABROSSÓN</h1> -->
    <!--   <button onclick="moverseA('abajo')" type="button" class="btn btn-outline-warning btn-lg">Ver Menú</button>
         -->

    <br>
    <a href="/home/galletas#productos" id="btnMenu" class="btn btn-light">Ver productos</a>

    <!--  <button type="button" id="btnMenu" class="btn btn-light ">Ver productos</button> -->
  </div>


</div>
<br><br>
<div id="productos">
</div>
<div id="titleMenu">

  <h1 class="font-weight-bold text-center" style="font-size:3em;">Gelletas</h1>
</div>
<div class="container text-center">


  <br>
  <div class="row">
    <div class="col">
      
      <div class="card text-center d-flex justify-content-between aling-items-center" style="width: 18rem;">
        
         
        <div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel">
          <ol class="carousel-indicators">
            <li data-target="#carouselExampleIndicators" data-slide-to="0" class="active"></li>
            <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
            <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
            <li data-target="#carouselExampleIndicators" data-slide-to="3"></li>
            <li data-target="#carouselExampleIndicators" data-slide-to="4"></li>
            <li data-target="#carouselExampleIndicators" data-slide-to="5"></li>
          </ol>
          <div class="carousel-inner">
            <div class="carousel-item active">
              <img class="d-block w-100" src="assets/img/galleta1.jpg" alt="First slide">
              <!-- <div class="carousel-caption d-none d-md-block">
                <h5>Desliza</h5>
                
              </div> -->
            </div>
            <div class="carousel-item">
              <img class="d-block w-100" src="assets/img/G1.jpg" alt="Second slide">
            </div>
            <div class="carousel-item">
              <img class="d-block w-100" src="assets/img/G2.jpg" alt="Third slide">
            </div>
            <div class="carousel-item">
              <img class="d-block w-100" src="assets/img/G3.jpg" alt="Second slide">
            </div>
            <div class="carousel-item">
              <img class="d-block w-100" src="assets/img/G4.jpg" alt="Third slide">
            </div>
            <div class="carousel-item">
              <img class="d-block w-100" src="assets/img/G5.jpg" alt="Third slide">
            </div>
          </div>
          <a class="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="sr-only">Previous</span>
          </a>
          <a class="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="sr-only">Next</span>
          </a>
        </div>
       
       <!--  <img class="card-img-top" src="assets/img/galleta1.jpg" alt="Card image cap"> -->
        <div class="card-body text-center">
          <h5 class="card-title">Galletas surtidas</h5>
          <div id="textp">
            <p class="card-text">Sabores: Chocolate, Chispas de colores, Tradicional, Relleno de Fresa, Polvoron de Naranja</p>
          </div>
 <h2 class="font-weight-bold">$60</h2>
          <!--  <a routerLink= "/home/huarache" class="btn btn-dark">Ordenar</a> -->
        </div>
      </div>
    </div>
    <!--
    <div class="col">
      <div class="card" style="width: 18rem;">
        <img class="card-img-top" src="assets/img/galletaN.jpg" alt="Card image cap">
        <div class="card-body">
          <h5 class="card-title">Orejitas tradicionales</h5>
          <div id="textp">
            <p class="card-text">La caja contiene 50 piezas</p>
          </div>
          
          <h2 class="font-weight-bold">$35</h2>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="card" style="width: 18rem;">
        <img class="card-img-top" src="assets/img/galletaC.jpg" alt="Card image cap">
        <div class="card-body">
          <h5 class="card-title">Orejitas con chocolate</h5>
          <div id="textp">
           <p class="card-text">La caja contiene 50 orejitas con chocolate.</p>
          
          </div>
           <h2 class="font-weight-bold">$35</h2>
        </div>
      </div>
    </div> -->







    <!-- Button trigger modal -->
    <div class="icon-wts-abajo">

      <img class="icon-wts" src="assets/img/wha.png" alt="" id="wtsicon" data-toggle="modal"
        data-target="#exampleModal">
      <h6>Ordena aquí</h6>
    </div>


    <!-- Modal -->
    <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
      aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Desglosa tu pedido aquí</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <br>
            <div>

              <i class="fas fa-motorcycle fa-lg" style="font-size: 50px;"></i>
              <br><br>
            </div>

            <div class="alert alert-primary" role="alert">
              El monto de envío varia de precio dependiendo tu zona y se da a conocer
              una vez realizando tu orden.<br><br>
            </div>


            <form id="formulario">
              <div class="form-group">
                <label for="formGroupExampleInput">Nombre:</label>
                <input type="text" class="form-control" id="formGroupExampleInput" placeholder="Nombre" required>
              </div>
              <div class="form-group">
                <label for="domicilioText">Domicilio:</label>
                <input type="text" class="form-control" id="domicilioText" placeholder="Domicilio" required>
              </div>


              <div class="form-group">
                <label for="exampleFormControlTextarea1">Escribe tu pedido:</label>
                <textarea class="form-control" id="exampleFormControlTextarea1" rows="3" required></textarea>
              </div>

              <div class="modal-footer">
                <button type="button" class="btn btn-danger" data-dismiss="modal">Cancelar</button>
               <!-- <button id="sendbtn" type="button" class="btn btn-success"><i class="fab fa-whatsapp"></i> Enviar WhatsApp</button>
              -->   <button id="sendbtn"  type="submit"  class="btn btn-success"> <i class="fab fa-whatsapp"></i> Enviar WhatsApp</button>
        
              </div>
            </form>





          </div>
         
        </div>
      </div>
    </div>




  </div>
</div>